import { FlexRow } from '@/components/common/Flex';
import usePlaid from '@/components/plaid/usePlaid';
import { Box } from '@chakra-ui/react';
import React from 'react';
import { Button } from '../common/Button';
import { FlexCol } from '../common/Flex';
import { SIDEBAR_WIDTH } from '../common/pageLayout/LeftNavSidebar';

interface FtuOverlayProps {
    title: React.ReactNode;
    ctaText?: string;
    items: { icon: React.ReactNode; text: React.ReactNode }[];
    onClick?: VoidFunction;
    isSubmitting?: boolean;
}

const FtuOverlay = ({
    title,
    ctaText,
    items,
    onClick,
    isSubmitting,
}: FtuOverlayProps) => {
    const { open } = usePlaid();

    return (
        <>
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="white"
                opacity={0.9}
                zIndex={0}
            />
            <FlexRow
                position="fixed"
                zIndex={1200}
                left={`calc(50% + ${SIDEBAR_WIDTH / 2}px)`}
                top="450px"
                bg="white"
                w={617}
                boxShadow="sm"
                p={12}
                transform="translateX(-50%) translateY(-100%)"
                border="1px solid"
                borderColor="gray.200"
                borderRadius="md"
            >
                <FlexCol pr={2} flex={1} justify="space-between">
                    {title}
                    <Button
                        w="75%"
                        h={12}
                        mt={4}
                        onClick={onClick || open}
                        onClickEvent={`${ctaText || 'Connect Account'} Button Clicked`}
                        onClickEventParams={{ location: 'Overlay' }}
                        isLoading={isSubmitting}
                    >
                        {ctaText ?? 'Connect an account'}
                    </Button>
                </FlexCol>
                <FlexCol flex={1} gap={12} pl={2}>
                    {items.map(({ icon, text }, i) => (
                        <FlexRow key={i} align="flex-start" gap={4}>
                            {icon}
                            {text}
                        </FlexRow>
                    ))}
                </FlexCol>
            </FlexRow>
        </>
    );
};

export default FtuOverlay;
